import Header from "@/components/layout/Header";
import { SongOrderForm } from "@/components/song-form";

const CreateSong = () => {
  return (
    <div className="min-h-screen bg-background music-note-pattern">
      <Header />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <SongOrderForm />
        </div>
      </main>
    </div>
  );
};

export default CreateSong;
